module.exports = __webpack_public_path__ + "img/courseIcon.4a7beae0.png";